/** Возвращает true, если переданное значение нельзя преобразовать в число больше 0 */
export const isDateSectionValueInvalid = (value: string | null) => !value || !Number(value) || Number.isNaN(+value);
